import { init, track as plausibleTrack } from "@plausible-analytics/tracker";
import { zaraz } from "zaraz-ts";

export function trackEvent(name: string, data?: Record<string, any>) {
    try {
        plausibleTrack(name, { props: data });
        zaraz.track(name, data);
    } catch {}
}
